import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';
import { t, type TranslationKey } from '../i18n';

const APP_NAME = 'SAISOKU';

/**
 * Custom hook to dynamically update the page title based on the current route.
 * Reads the titleKey from route metadata and formats as "{title} | SAISOKU".
 */
export const usePageTitle = (): void => {
  const matches = useMatches();
  const titleKey = (
    matches[matches.length - 1]?.handle as { titleKey?: TranslationKey } | undefined
  )?.titleKey;

  useEffect(() => {
    let pageTitle = APP_NAME;

    if (titleKey) {
      const title = t(titleKey);
      pageTitle = `${title} | ${APP_NAME}`;
    }

    document.title = pageTitle;
  }, [titleKey]);
};
